'use strict';

const outOfStock = {
    elements: {
        $document: $(document),
        $body: $('body'),
        $outOfStock: $('.js-alert-product'),
    },

    selectors: {
        outOfStock: '.js-alert-product',
        outOfStockForm: '.js-alert-product-form',
        emailInput: '.js-alert-product-email',
        submitButton: '.js-alert-product-submit-btn',
        successFeedback: '.js-alert-product-success-feedback',
        invalidFeedback: '.js-alert-product-invalid-feedback',
    },

    modifiers: {
        hiddenFeedbacks: 'hidden',
    },

    settings: {
        emailRegex: '/^[\w\-\.]+@([\w\-]+\.)+[a-zA-Z]{2,}$/',
    },

    init() {
        if(this.elements.$outOfStock.length) {
            this.initEvents();

            const $emailInput = this.elements.$outOfStock.find(this.selectors.emailInput);

            if($emailInput.val().trim()) {
                $emailInput.trigger('input');
            }
        }
    },

    initEvents() {
        this.elements.$outOfStock.on('input', this.selectors.emailInput, (e) => this.validateEmail(e));
        this.elements.$outOfStock.on('submit', this.selectors.outOfStockForm, (e) => this.handleSubmitForm(e));
    },

    validateEmail(e) {
        const $currentParentForm = $(e.target).closest(this.selectors.outOfStockForm);
        const $currentEmail = $currentParentForm.find(this.selectors.emailInput);
        const $currentSubmitButton = $currentParentForm.find(this.selectors.submitButton);
        const emailRegex = new RegExp($currentEmail.attr('data-pattern') || this.settings.emailRegex);
        const isEmailValid = emailRegex.test($currentEmail.val().trim());

        this.handleInvalidFeedback($currentParentForm, isEmailValid);
        this.handleDisableButton($currentSubmitButton, !isEmailValid);
    },

    handleSubmitForm(e) {
        e.preventDefault();
        const $currentForm = $(e.target).closest(this.selectors.outOfStockForm);

        $.ajax({
            url: $currentForm.data('action'),
            method: $currentForm.attr('method'),
            data: $currentForm.serialize(),
            success: (data) => {
                this.handleSuccessFeedback($currentForm, false); // Show success msg
                this.handleDataTracking(data);
                this.handleDisableButton($currentForm.find(this.selectors.submitButton), true); // Disable button
                $currentForm.find(this.selectors.emailInput).val(''); // Clean input
            },
            error: () => {
            }
        });
    },

    handleSuccessFeedback($currentForm, state) {
        $currentForm.find(this.selectors.successFeedback).toggleClass(this.modifiers.hiddenFeedbacks, state); // Show success msg
    },

    handleDataTracking(data) {
        try {
            data.gtm !== null && dataLayer.push(data.gtm);
        } catch (e) {
            console.warn('Unable to trigger alert OOS GTM')
        }
    },

    handleInvalidFeedback($currentForm, state) {
        this.handleSuccessFeedback($currentForm, true); // Hide success msg
        $currentForm.find(this.selectors.invalidFeedback).toggleClass(this.modifiers.hiddenFeedbacks, state); // Show invalid msg
    },

    handleDisableButton($button, state) {
        $button
            .prop('disabled', state)
            .toggleClass('disabled', state)
            .attr('aria-disabled', state);
    }
};

outOfStock.init();

